import {ObrigacaoAplicacaoVO, ObrigacaoAplicacao} from '.'

export class ConsolidacaoAplicacaoVO {

  obrigacaoAplicacao: ObrigacaoAplicacaoVO;
  aplicacaoPdiGasto: ObrigacaoAplicacaoVO;
  aplicacaoPdiCumprimento: ObrigacaoAplicacaoVO;
  demaisAplicacoes: ObrigacaoAplicacao;


}
